import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactContext, useCustomFields, useSchema, } from "@/contexts/contact";
import { useContactingTestId } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Button, Modal } from "@gemini/ui";
import { useFormContext } from "react-hook-form";
import { Box, useBreakpointValue } from "@gemini/core";
import { contactFormFieldsTestId } from "../../ContactForm/ContactFormFields/constants";
import { EmailInput } from "../../ContactForm/ContactFormFields/EmailInput";
import { PhoneNumberInput } from "../../ContactForm/ContactFormFields/PhoneNumberInput";
import { usePrefillDataCookie } from "../../ContactForm/usePrefillDataCookie";
import { FullNameInput } from "../../ContactForm/ContactFormFields/FullNameInput";
import { getFeaturesEnabled } from "@/utils";
import { StreetInput } from "../../ContactForm/ContactFormFields/StreetInput";
import { ZipCityInput } from "../../ContactForm/ContactFormFields/ZipCityInput";
import { useCombinedUserData } from "../../hooks/useCombinedUserData";
export const PersonalDataModal = () => {
    const { t } = useI18n();
    const { isPersonalDataModalOpen, togglePersonalDataModal, setUserData, userData, defaultMessage, } = useContactContext();
    const rootTestID = useContactingTestId("PersonalDataModal");
    const { setPrefillDataCookie } = usePrefillDataCookie();
    const { phoneNumber, street, zipCode } = useSchema().shape;
    const gap = "spacing.16";
    const { control, handleSubmit, reset, getValues } = useFormContext();
    const combinedUserData = useCombinedUserData(userData !== null && userData !== void 0 ? userData : undefined);
    const isMobile = useBreakpointValue({
        base: true,
        lg: false,
    });
    const { extendedContactForm } = getFeaturesEnabled();
    const { locationEnabled } = useCustomFields();
    const showExtendedContactForm = locationEnabled && extendedContactForm;
    const onSave = (formData) => {
        setUserData(formData);
        setPrefillDataCookie(formData);
        togglePersonalDataModal();
    };
    const handleSaveAndClose = () => {
        handleSubmit(onSave)();
    };
    return (_jsx(Modal, { testId: rootTestID, title: t("contact.personal_data.title"), titleAs: "h2", trigger: () => null, isOpen: isPersonalDataModalOpen, onOpenChange: (open) => {
            if (!open) {
                const currentFormValues = getValues();
                reset(Object.assign(Object.assign({}, combinedUserData), { message: currentFormValues.message != null
                        ? currentFormValues.message
                        : defaultMessage, isOwner: currentFormValues.isOwner, newsletterOptout: currentFormValues.newsletterOptout }));
                togglePersonalDataModal();
            }
        }, isDismissable: true, children: _jsxs(Box, { testId: contactFormFieldsTestId, display: "flex", flexDirection: "column", gap: gap, children: [_jsx(Box, { display: "flex", flexDirection: isMobile ? "column" : "row", gap: gap, children: _jsx(FullNameInput, { control: control, required: true }) }), _jsx(EmailInput, { control: control, required: true }), _jsx(PhoneNumberInput, { control: control, required: !phoneNumber.isOptional() }), showExtendedContactForm && (_jsxs(_Fragment, { children: [_jsx(StreetInput, { control: control, required: !street.isOptional() }), _jsx(ZipCityInput, { control: control, required: !zipCode.isOptional() })] })), _jsx(Box, { gap: gap, children: _jsx(Button, { onPress: handleSaveAndClose, isFullWidth: true, size: "48", children: t("common.CTA.save.label") }) }), _jsxs(Box, { typography: "typography.body.11.regular", children: ["* ", t("contact.form.required_fields")] })] }) }));
};
